import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertOtherDocumentLinkCommand from './insertotherdocumentlinkcommand';

export default class InsertOtherDocumentLinkUI extends Plugin {

  init() {
    this.editor.commands.add('insertotherdocumentlink', new InsertOtherDocumentLinkCommand(this.editor));
  }
}